module.exports = __webpack_public_path__ + "img/2012-12-01 14.56.35.940e7990.jpg";